import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
import { CHECKOUT_URL } from './Shared';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 8,
    s: 54
  });
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => {
        const seconds = current.h * 3600 + current.m * 60 + current.s;
        if (seconds <= 0) return current;
        const next = seconds - 1;
        return {
          h: Math.floor(next / 3600),
          m: Math.floor(next % 3600 / 60),
          s: next % 60
        };
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const formattedTime = `${String(timeLeft.h).padStart(2, '0')}:${String(timeLeft.m).padStart(2, '0')}:${String(timeLeft.s).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/50 bg-brand-ink text-brand-paper shadow-md" data-id="element-288" data-mp="1bwgcr7f6ljyd">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-3 px-3 py-2 text-[11px] font-medium sm:gap-5 md:px-6 md:py-2.5 md:text-sm" data-id="element-289" data-mp="1guhxrxw63tch">
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-goldLight" data-id="element-290" data-mp="22nq3gmjsiwlb">
          <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-291" data-mp="1xodjqao7u5my">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-cinnabar opacity-75" data-id="element-292" data-mp="1xmk80gyqwv83" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-cinnabar" data-id="element-293" data-mp="2qe3z0n1l3dkn" />
          </span>
          <strong className="uppercase tracking-[0.14em]" data-id="element-294" data-mp="2ldzdujpqduo3">
            Oferta de lanzamiento
          </strong>
        </div>
        <span className="h-4 w-px bg-brand-gold/45" aria-hidden="true" data-id="element-295" data-mp="2ge3ammouy79l" />
        <div className="flex items-center gap-1.5 whitespace-nowrap text-brand-paper" data-id="element-296" data-mp="2cech4b7y5d1d">
          <ClockIcon className="h-3.5 w-3.5 text-brand-goldLight" aria-hidden="true" data-id="element-297" data-mp="14zzg9fecyh40" />
          <span className="hidden sm:inline" data-id="element-298" data-mp="10xl0j45zjxgy">Finaliza en</span>
          <span className="font-mono font-bold tabular-nums text-brand-goldLight" data-id="element-299" data-mp="12ftened7v2qm">
            {formattedTime}
          </span>
        </div>
        <a href={CHECKOUT_URL} className="rounded-sm border border-brand-goldLight/60 bg-brand-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-brand-ink transition-colors duration-150 ease-out hover:bg-brand-goldLight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-paper sm:px-3 sm:text-xs" data-id="element-300" data-mp="17duza3qaja47">
          Ver pack →
        </a>
      </div>
    </div>;
}